import { Component } from '@angular/core';
import { UserContractCollection } from '../UserContractCollection';
import { CollectionUserApi, OrganizationContractService } from '@shared/services/contract.service';
import { ContractCluster } from '@shared/models/contract';
import { NgxDatatableModule } from '@siemens/ngx-datatable';
import { HostModeLabelComponent } from '@shared/components/label/host-mode-label/host-mode-label.component';
import { TablePagerComponent } from '@shared/components/table-pager/table-pager.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-contract-clusters',
  templateUrl: './contract-clusters.component.html',
  styleUrl: './contract-clusters.component.scss',
  imports: [NgxDatatableModule, HostModeLabelComponent, TablePagerComponent, TranslatePipe],
})
export class ContractClustersComponent extends UserContractCollection<ContractCluster> {
  constructor(protected userContractService: OrganizationContractService) {
    super(userContractService);
  }

  protected getCollectionApi(): CollectionUserApi<ContractCluster> {
    return this.userContractService.clusters(this.contractNumber);
  }
}
